import React from 'react'
import { Card, CardBody, Col, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap'
import FeatherIcon from "feather-icons-react";
import { Link } from 'react-router-dom';
import slack from '../../assets/images/brands/slack.png';

export default function ClientCard({ data, toggleContactPersonAddModal }) {

    const apiImageUrl = process.env.REACT_APP_API_IMAGE_URL;

    return (
        <>
            <Col lg={6} xl={6} xxl={4} sm={6} className="project-card pe-1 ps-1">
                <Card className="mb-2">
                    <CardBody>
                        <div className="d-flex flex-column h-100">
                            <div className="d-flex">
                                <div className="flex-grow-1">
                                    <p
                                        className="text-dark fs-8 mb-4"
                                        style={{
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            width: "300px"
                                        }}
                                    >
                                        {data.companyName}
                                    </p>
                                </div>
                                <div className="flex-shrink-0">
                                    <div className="d-flex gap-1 align-items-center">
                                        <UncontrolledDropdown direction='start'>
                                            <DropdownToggle tag="button" className="btn btn-link text-muted p-1 mt-n2 py-0 text-decoration-none fs-15  material-shadow-none">
                                                <FeatherIcon icon="more-horizontal" className="icon-sm" />
                                            </DropdownToggle>

                                            <DropdownMenu className="dropdown-menu-end">
                                                <Link to={`/view-client/${data.id}`}>
                                                    <DropdownItem>
                                                        <i className="ri-eye-fill align-bottom me-2 text-muted"></i> View Details
                                                    </DropdownItem>
                                                </Link>
                                                <Link to={`/manage-project/${data.id}`}>
                                                    <DropdownItem>
                                                        <i className="ri-folder-settings-fill align-bottom me-2 text-muted"></i> Manage Projects
                                                    </DropdownItem>
                                                </Link>
                                                <Link to={`/manage-license/${data.id}`}>
                                                    <DropdownItem>
                                                        <i className="ri-file-lock-fill align-bottom me-2 text-muted"></i> Manage License
                                                    </DropdownItem>
                                                </Link>
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex">
                                <div className="me-3">
                                    <div className="avatar-xs">
                                        <span className="avatar-title p-0 bg-warning-subtle rounded-border">
                                            <img src={apiImageUrl + data.file} onError={(e) => { e.target.src = slack }} alt="..." className="img-fluid p-1 rounded-circle" />
                                        </span>
                                    </div>
                                </div>
                                <div>
                                    <div className='d-flex align-items-center mb-3'>
                                        <h5 className="mb-0 fs-13 me-2">Contact Person -</h5>
                                        {
                                            data.contactName === null ? <i className="ri-pencil-fill me-2 cursor-pointer" onClick={() => toggleContactPersonAddModal(data.id)}></i> :
                                                <p className='mb-0 fs-12'>{data.contactName}</p>
                                        }
                                    </div>
                                    <div className='d-flex align-items-center'>
                                        <h5 className="mb-0 fs-13 me-2">Email -</h5>
                                        <p className='mb-0 fs-12'
                                            style={{
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                width: "200px"
                                            }}
                                        >{data.email}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </CardBody>
                    <div className="card-footer bg-transparent border-top-dashed py-2">
                        <div className="d-flex align-items-center">
                            <div className="flex-grow-1">
                                <div className="avatar-group d-flex align-items-center">
                                    <div>
                                        <h6 className="mb-0 fs-12">Entry Date</h6>
                                        <p className="text-muted mb-0 fs-10">{data.entryDate}</p>
                                    </div>
                                </div>
                            </div>
                            {
                                data.city === null ? '' :
                                    <div className="flex-shrink-0 d-flex align-items-center">
                                        <i className="ri-map-pin-2-line text-primary me-1"></i>{" "}
                                        <h6 className="mb-0 fs-12">{data.city}</h6>
                                    </div>
                            }
                        </div>
                    </div>
                </Card>
            </Col >
        </>
    )
}
